module.exports = __webpack_public_path__ + "img/ug.f37753b1.png";